module.exports = __webpack_public_path__ + "static/media/mamorepo01.5798165b.jpg";